module.exports = __webpack_public_path__ + "static/media/Medium.f2a32dfa.png";